var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationFeaturesTab2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 478,
    height: 416,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 350,
    height: 346,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 200,
    height: 255,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "117.5%",
    height: "113.7%",
    x: "-8.8%",
    y: "-4.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.285332669 0 0 0 0 0.363695184 0 0 0 0 0.811480978 0 0 0 0.0830692745 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "139.5%",
    height: "131%",
    x: "-19.8%",
    y: "-13.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.285332669 0 0 0 0 0.363695184 0 0 0 0 0.811480978 0 0 0 0.0830692745 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "g",
    width: 200,
    height: 255,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "117.5%",
    height: "113.7%",
    x: "-8.8%",
    y: "-4.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.285332669 0 0 0 0 0.363695184 0 0 0 0 0.811480978 0 0 0 0.0830692745 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E8EAF6",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242A45",
    d: "M-3.53.197h547v59h-547z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.47 14.197)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    opacity: 0.245
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    opacity: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    y: 14,
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 138)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 168)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    transform: "translate(251 138)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FA5959"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 168)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.317,
    height: 6,
    x: 45.683,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.036,
    height: 6,
    x: 45.683,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 34,
    x: 27,
    y: 85,
    fill: "#FFF",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#5267DF",
    strokeWidth: 20,
    transform: "translate(305 102)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 67,
    r: 67,
    fill: "#495DCF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M114 115l49 49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFeaturesTab2);
export default __webpack_public_path__ + "static/media/illustration-features-tab-2.e933bd6d921c537d7743e08ea4ec488e.svg";
export { ForwardRef as ReactComponent };